<template>
	<v-main>
		<slot></slot>
	</v-main>
</template>
